module.exports = __webpack_public_path__ + "assets/eafbc55a262a18f599e32569c776930f.png";